import { create } from 'zustand';
import { repository, storage } from '../../app-loader';
import { generateScanCode } from '../../utils/generate-scan-code';
import useAppStore from '../../app-store';

const useStore = create((set, get) => ({
  loading: true,
  setLoading: (payload) => set({ loading: payload }),
  token: '',
  expiredAt: 0,
  donateData: null,
  setDonateData: (payload) => set({ donateData: payload }),
  receiptBarcodeHide: false,
  toggleReceiptBarcodeHide: () =>
    set((state) => ({ receiptBarcodeHide: !state.receiptBarcodeHide })),
  setReceiptBarcodeHide: (payload) => set({ receiptBarcodeHide: payload }),
  barcodePaymentDialog: null,
  setBarcodePaymentDialog: (payload) => set({ barcodePaymentDialog: payload }),
  barcodeUrl: '',
  qrcodeUrl: '',
  barcodeCountdownTime: 0,
  setBarcodeCountdownTime: (payload) => set({ barcodeCountdownTime: payload }),
  hintBoard: null,
  setHintBoard: (payload) => set({ hintBoard: payload }),
  barcodeCountdown: false,
  setBarcodeCountdown: (payload) => set({ barcodeCountdown: payload }),
  barcodePaymentResult: null,
  setBarcodePaymentResult: (payload) =>
    set({ barcodeCountdown: false, barcodePaymentResult: payload }),
  fetchBoards: async () => {
    Promise.all([
      repository.fetchBarcodePaymentPopupBoard(),
      repository.fetchBarcodePaymentHintBoard(),
    ])
      .then((result) => {
        for (const data of result) {
          if (data.error) throw data.error;
        }

        const popupBoard = result[0].data[0];
        const hintBoard = result[1].data[0];

        if (
          !storage.getBarcodePaymentViewedBoardList() ||
          storage.getBarcodePaymentViewedBoardList().indexOf(popupBoard.id) ===
            -1
        ) {
          storage.saveBarcodePaymentViewedBoardList(popupBoard.id);

          get().setBarcodePaymentDialog({
            type: 'popup_board',
            id: popupBoard.id,
            title: popupBoard.attributes.title,
            content: popupBoard.attributes.content,
            buttonText: popupBoard.attributes.buttonText,
          });
        }

        get().setHintBoard({
          title: hintBoard.attributes.title,
          action: hintBoard.action,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  },
  fetchBarcodePaymentData: async (callback) => {
    get().setLoading(true);

    const appStore = useAppStore.getState();

    const { error, data } = await repository.fetchPaymentToken(
      appStore.defaultPlate?.plateNumber,
    );
    if (error) {
      const result = () => {
        switch (error?.response?.data.error.code) {
          case 'user_has_no_credit_card':
            return {
              type: 'no_payment',
              content: '您沒有綁定付款方式，請綁定後再重新嘗試。',
            };
          case 'user_payment_frozen':
            return {
              type: 'fetch_fail',
              content: '您的帳戶已被凍結，請解除凍結後再重新嘗試。',
            };
          default:
            return {
              type: 'fetch_fail',
              content: '目前無法讀取付款條碼，請稍後再嘗試。',
            };
        }
      };
      return get().setBarcodePaymentDialog(result());
    }

    if (callback) callback();

    let scanCodeUrl = await generateScanCode(data.token);

    set({
      token: data.token.toUpperCase(),
      expiredAt: data.expiredAt,
      barcodeUrl: scanCodeUrl.barcode,
      qrcodeUrl: scanCodeUrl.qrcode,
      loading: false,
    });
  },
}));

export default useStore;
